import axios from 'axios'

// Fallback so status labels/colors never break before `api/status/list` has loaded,
// or for a `type` the admin-configured list doesn't have a row for yet. Values match
// what was hardcoded across the app before statuses became admin-configurable.
export const FALLBACK_STATUS_META = {
  new_order: { display_name_en: 'New Order', color: '#DEC384' },
  pending_answer: { display_name_en: 'Pending Answer', color: '#FFD97D' },
  processed_order: { display_name_en: 'Processed Order', color: '#FFC85C' },
  canceled: { display_name_en: 'Canceled', color: '#F63049' },
  approved_order: { display_name_en: 'Approved Order', color: '#6EADBC' },
  refunded: { display_name_en: 'Refunded', color: '#FF6B81' },
  purchased: { display_name_en: 'Purchased', color: '#84B179' },
  warehouse_delivered_order: { display_name_en: 'Warehouse Delivered Order', color: '#831C91' },
  int_shipment: { display_name_en: 'Int Shipment', color: '#A655BE' },
  pending_to_shipment: { display_name_en: 'Pending To Shipment', color: '#C28FD8' },
  branch_delivery: { display_name_en: 'Branch Delivery', color: '#685AFF' },
  delivered: { display_name_en: 'Delivered', color: '#89D7B7' },
  archived: { display_name_en: 'Archived', color: '#B0BEC5' },
  ship_only: { display_name_en: 'Ship Only', color: '#29B6F6' },
  pending_to_branch: { display_name_en: 'Pending To Branch', color: '#8B82FF' },
  damage: { display_name_en: 'Damage', color: '#760031' },
  return: { display_name_en: 'Return', color: '#F1FF5E' }
}

/**
 * Shared admin/customer mixin for the single source of truth on order-status
 * display name, color, and visibility (`api/status/list` / `api/status/{id}`,
 * backed by `App\Status`'s admin-configurable columns). Components that need the
 * live status list (dropdowns, badges, nav gating) should call `$_fetch_statuses()`
 * on mount and read `this.statusList` / the `$_status_*` helpers below.
 */
export default {
  data() {
    return {
      statusList: []
    }
  },

  methods: {
    $_fetch_statuses() {
      const token = localStorage.getItem('access_token')

      return axios
        .get('api/status/list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.statusList = response.data || []
          return this.statusList
        })
    },

    $_status_meta(type) {
      const found = this.statusList.find(s => s.type === type)
      const fallback = FALLBACK_STATUS_META[type] || {
        display_name_en: (type || '').replace(/_/g, ' '),
        color: '#F5F5F5'
      }

      // Prefer the admin-configured name in the currently selected app language
      // (falls through to English, then the hardcoded fallback, if that language's
      // column hasn't been filled in for this status yet).
      const locale = (this.$i18n && this.$i18n.locale) || 'en'
      const localizedLabel = found && found['display_name_' + locale]

      return {
        label: localizedLabel || (found && found.display_name_en) || fallback.display_name_en,
        color: (found && found.color) || fallback.color,
        isVisible: found ? found.is_visible !== false : true
      }
    },

    $_status_label(type) {
      return this.$_status_meta(type).label
    },

    $_status_color(type) {
      return this.$_status_meta(type).color
    },

    $_status_visible(type) {
      return this.$_status_meta(type).isVisible
    },

    $_visible_status_list() {
      return this.statusList.filter(s => s.is_visible !== false)
    },

    // Picks black or white text over an admin-chosen background color, using
    // perceived-luminance (so a status badge stays readable no matter what
    // color the admin sets it to).
    $_readable_text_color(hex) {
      const clean = (hex || '').replace('#', '')
      if (clean.length !== 6) return '#000000'

      const r = parseInt(clean.substring(0, 2), 16)
      const g = parseInt(clean.substring(2, 4), 16)
      const b = parseInt(clean.substring(4, 6), 16)
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

      return luminance > 0.6 ? '#000000' : '#FFFFFF'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/statusHelpers.js